
import { debounce } from '~/mixins/helpers';
import { createNamespacedHelpers } from 'vuex';
import respUtility from '~/mixins/respUtility';

const { mapState, mapMutations } = createNamespacedHelpers('listing');

export default {
  name: 'ListingFiltersContent',
  mixins: [respUtility],
  props: {
    currentFiltersBlock: {
      type: Array,
      default() {
        return [];
      },
    },
    searchParams: {
      type: Object,
      default() {
        return {};
      },
    },
    active: {
      type: Boolean,
      default: false,
    },
    attrs: {
      type: Object,
      default() {
        return {};
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    resultItemsCount: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    openPanelsArr: [],
    openCUser: [],
    showShadow: false,
    subTitleCat: null,
    subTitleSubCat: null,
    componentsNames: {
      brand: 'ListingFiltersPanelBrands',
      price: 'ListingFiltersPanelPrice',
      layout_navigate: 'ListingFiltersPanelLayoutNavigate',
      cat: 'ListingFiltersPanelCommonNew',
      subCat: 'ListingFiltersPanelCommonNew',
      collection_type: 'ListingFiltersPanelCollection',
    },
  }),
  computed: {
    ...mapState(['currentSelected']),
    isMobile() {
      return this.$device.isMobileOrTablet || this.isTouchDevice;
    },
    selectedCount() {
      const result = {};
      this.filtersDataSort.forEach((item) => {
        result[item.attrCode] = 0;
        if (Array.isArray(this.selected[item.attrCode])) {
          result[item.attrCode] = this.selected[item.attrCode]?.length;
        }
        if (item.attrCode === 'price' && this.customPrice) {
          result[item.attrCode] += 1;
        }
      });
      return result;
    },
    panels: {
      get() {
        if (!this.isMobile) {
          let result = Object.keys(this.filtersDataSort).map((i) => Number(i));
          if (this.subTitleCat) {
            result = result.filter((item) => item !== 0);
          }

          if (this.subTitleSubCat) {
            result = result.filter((item) => item !== 1);
          }

          return result;
        }
        const opened = [...this.openPanelsArr];
        return opened.reduce((acc, name) => {
          const index = this.filtersDataSort.findIndex((item) => item.attrCode === name);
          if (index > -1) {
            acc.push(index);
          }
          return acc;
        }, []);
      },
      set(arrNumbers) {
        this.openPanelsArr = arrNumbers.reduce((arr, n) => {
          if (this.filtersDataSort[n]) {
            arr.push(this.filtersDataSort[n].attrCode);
          }
          return arr;
        }, []);
      },
    },
    filtersDataSort() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.subTitleCat = null;
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.subTitleSubCat = null;
      const newFiltersBlock = [];

      this.currentFiltersBlock?.forEach((filterBlock) => {
        const { attrCode, facets } = filterBlock;

        newFiltersBlock.push(filterBlock);

        if (attrCode === 'cat' && this.selected?.cat?.length) {
          facets?.forEach((facet) => {
            const match = this.selected.cat.find((selectedFacet) => selectedFacet.attrValue === facet.attrValue);
            const childMatch = facet.child?.find((childFacet) => this.selected.cat.some(
              (selectedFacet) => selectedFacet.attrValue === childFacet.attrValue,
            ));
            if ((match || childMatch) && facet?.child?.length > 0) {
              this.subTitleCat = facet.attrLabel;
              newFiltersBlock.push({
                attrCode: 'subCat',
                header: facet.attrLabel,
                facets: facet.child,
              });
            }
          });
        }
      });
      const selectedCatValues = this.selected?.cat?.map((item) => item.attrValue);
      newFiltersBlock?.forEach((filterBlock) => {
        if (filterBlock.attrCode === 'subCat') {
          // eslint-disable-next-line no-param-reassign
          filterBlock.facets.forEach((facet) => {
            if (selectedCatValues.includes(facet.attrValue)) {
              this.subTitleSubCat = facet;
            }
          });
        }
      });
      return newFiltersBlock || [];
    },
    selected() {
      return this.currentSelected.selected;
    },
    customPrice() {
      return this.currentSelected.customPrice;
    },
    routeSelected() {
      return this.searchParams ? this.searchParams.facet : null;
    },
    openC: {
      get() {
        return this.openCUser;
      },
      set(value) {
        this.openCUser = value;
      },
    },
  },
  watch: {
    active(status) {
      if (!status) {
        this.panels = [];
      }
    },
    filtersDataSort(arr, o) {
      const cat = arr.find((i) => i.attrCode === 'cat');
      const subCat = arr.find((i) => i.attrCode === 'subCat');
      if (subCat && !this.openPanelsArr.includes('subCat')) {
        const result = this.openPanelsArr.filter((item) => item !== 'cat');
        this.openPanelsArr = [...result, 'subCat'];
      }
      if (!this.isMobile) {
        if (cat && !subCat && !this.openPanelsArr.includes('cat')) {
          const result = this.openPanelsArr.filter((item) => item !== 'subCat');
          this.openPanelsArr = [...result, 'cat'];
        }
      } else if (this.isMobile && this.subTitleSubCat) {
        const result = this.openPanelsArr.filter((item) => item !== 'subCat');
        this.openPanelsArr = [...result];
      }
      if (!o?.length && this.routeSelected?.cat?.length) {
        if (cat?.facets) {
          const result = [];
          this.routeSelected?.cat.forEach((cid) => {
            const parent = cat.facets.find((f) => {
              if (!f?.child?.length) {
                return false;
              }
              return f.child.some((subc) => subc.attrValue === cid);
            });
            if (parent && !result.includes(parent.attrValue)) {
              result.push(parent.attrValue);
            }
          });
          this.openC = result.map((key) => ({ attrValue: key }));
        }
      }
    },
    resultItemsCount() {
      if (!this.isMobile) {
        this.updatePosition();
      }
    },
  },
  mounted() {
    const type = this.$store.state.pageData?.globalType;
    if (!this.isMobile && !(type === 'PLP' || type === 'SEARCH_RESULTS')) {
      const result = [];
      Object.entries(this.routeSelected || {}).forEach(([attr, value]) => {
        if (!value?.length) {
          return;
        }
        result.push(attr);
      });
    }
  },
  methods: {
    ...mapMutations([
      'setSelected',
      'removeSelectedFilter',
    ]),
    changePanels(value) {
      const previouslyOpen = [...this.panels];
      this.panels = value;

      if (!this.isMobile || value.length === 0) return;

      const newlyOpened = value.filter((v) => !previouslyOpen.includes(v));

      if (newlyOpened.length === 0) return;

      const panelIndex = newlyOpened[newlyOpened.length - 1];
      const refName = `panel-${panelIndex}`;

      this.$nextTick(() => {
        setTimeout(() => {
          const el = this.$refs[refName]?.[0]?.$el;
          if (!el || typeof el.scrollIntoView !== 'function') return;

          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 300);
      });
    },
    openCategories(v) {
      const newAttrValue = v[0]?.attrValue;
      if (!newAttrValue) {
        return;
      }
      if (this.openC?.length > 0 && this.openC[0]?.attrValue === newAttrValue) {
        this.openC = [];
      } else {
        this.openC = [{ attrValue: newAttrValue }];

        const filterBlock = this.filtersDataSort?.find((block) => block.attrCode === 'cat');
        if (!filterBlock) {
          return;
        }
        const matchingFacet = filterBlock?.facets
          .find((facet) => facet?.child?.some((child) => child.attrValue === newAttrValue));

        if (matchingFacet) {
          this.openC = [{ attrValue: matchingFacet.attrValue }];
        }
      }
    },
    clearFilters(attrCode) {
      if (attrCode === 'price' && this.customPrice) {
        this.$store.commit('listing/setCustom', null);
        return;
      }
      if (attrCode === 'subCat' && this.subTitleSubCat) {
        const subCatAttrValue = this.subTitleSubCat?.attrValue;
        this.removeSelectedFilter({ selected: attrCode, attrValue: subCatAttrValue });
        return;
      }
      this.removeSelectedFilter({ selected: attrCode });
    },
    handleScroll: debounce(function debounceHandleScroll() {
      const { sidebar } = this.$refs;
      const isAtBottom = sidebar.scrollTop + sidebar.clientHeight >= sidebar.scrollHeight;
      if (!this.showShadow && sidebar.scrollTop > 0) {
        this.showShadow = true;
      }
      if (isAtBottom) {
        this.showShadow = false;
      }
    }, 100),
  },
};
